import React from "react";

// eslint-disable-next-line no-console
export const SoundContext = React.createContext({ sound: true, setSound: (sound: boolean): void => console.log(sound) });
